<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :args="args"
        :server-errors="serverErrors"
        :options="booleanYesNo"
        :no-save="false"
        :db="db"
        :disabled="!!assets.length"
        @jsErrors="jsErrors=$event"
        ref="input"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "../../../helpers/questionLoadHelpers";
import { general } from "../../../options/general";

import QuestionBase from "../../../QuestionBase";
import InputRadio from "../../../inputs/InputRadio";

export default {
  name: 'AssetsOverYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    assets: {
      type: Array,
      required: true
    }
  },
  mounted () {
    // set initial question value (yes/no) based on assets
    if (this.assets.length && !this.data) {
      this.$refs.input.data = true
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title:  'Do you have any other significant assets?',
        subTitle:  'Please include anything worth more than £5,000.',
        tip: null,
      },
      db: {
        saveLocation: 'client_client',
        saveField: 'assets_other_high_value'
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>